import { permissionManager } from "../PermissionManager/PermissionManager";
import { HOME_ALL_LIST } from './home.constants' //HOME_SNAPSHOT,
import { isMobile as IS_MOBILE } from 'Utils/device';
import {
  CONVERT_FILES_TO_PDF,
  CONVERT_MUL_FILES_TO_PDF,
  CREATE_BLANK_PDF,
  CONVERT_CLIPBOARD_TO_PDF,
  CONVERT_HTML_TO_PDF,
  CONVERT_NEW_PORTFOLIO,
  CONVERT_BLANK_PORTFOLIO,
  CONVERT_COMBINE_FILES,
  CONVERT_EXPORT_IMAGES,
  CONVERT_PDF_TO_OFFICE,
  // CONVERT_PDF_TO_WORD,
  CONVERT_PDF_TO_XML_SPREADSHEET_2003,
  CONVERT_PDF_TO_WORD_2003,
  // CONVERT_PDF_TO_EXCEL,
  // CONVERT_PDF_TO_PPT,
  CONVERT_PDF_TO_IMAGE,
  CONVERT_PDF_TO_PNG,
  CONVERT_PDF_TO_JPEG,
  CONVERT_PDF_TO_JPEG2000,
  CONVERT_PDF_TO_TIFF,
  CONVERT_PDF_TO_BMP,
  CONVERT_PDF_TO_OTHER,
  CONVERT_TO_PDF_SETTINGS,
  CONVERT_PDF_TO_XML_STARDARD,
  CONVERT_PDF_TO_RTF,
  CONVERT_PDF_TO_TXT,
  CONVERT_PDF_TO_ACCESSIBLE_TXT,
  CONVERT_PDF_TO_HTML,
  CONVERT_PREFLIGHT,
  CONVERT_LIST,
  CONVERT_FROM_TEMPLATE,
  OCR_QUICK_RECOGNITION, HOME_OCR_QUICK_RECOGNITION,
} from './convert.constants';
import {
  CONVERT_PDF_TO_WORD,
  CONVERT_PDF_TO_EXCEL,
  CONVERT_PDF_TO_PPT,
  CONVERT_PDF_TO_IMG,
  EXPORT_ALL_IMG,
  OCR_PDF_TO_PDF
} from './fw.convert.constants';//TODO FOXIT 转换
import {
  HELP_CUSTOMER_SERVICE,
  HELP_ABOUT,
  HELP_OPEN_MEMBER,
  HELP_EXCHANGE_MEMBER
} from './fw.help.constants';//TODO FOXIT 帮助
//import {FILE_TAB_LIST} from './file.constants'
import { COMMON_ALL_LIST } from './common.constants'
import {
  FILE_TAB_TRUST_MANAGER,
  FILE_TAB_FILE_PREFERENCES,
  FILE_TAB_FILE_PROPERTIES,
  FILE_TAB_PDF_OPTIMIZER,
  FILE_TAB_PDF_REDUCE_SIZE,
  FILE_TAB_GROUP_FILE_OPTIMIZER,
  VIEW_TAB_COMPARE,
  FILE_TAB_PDF_OPTIMIZER_SCANNED,
  CREATE_NEW_ACTION,
  RUN_ACTION,
  MANAGE_ACTIONS,
} from './file.constants';
import {
  ORGANIZE_TAB_EXTRACT,
  ORGANIZE_TAB_MOVE,
  ORGANIZE_TAB_SPLIT,
  ORGANIZE_TAB_FLATTEN,
  ORGANIZE_TAB_WATERMARK,
  ORGANIZE_TAB_WATERMARK_ADD,
  ORGANIZE_TAB_WATERMARK_UPDATE,
  ORGANIZE_TAB_WATERMARK_REMOVEALL,
  HOME_TAB_WATERMARK_REMOVEALL,
  HOME_TAB_BACKGROUND_REMOVEALL,
  HOME_TAB_HEADERFOOTER_REMOVEALL,
  HOME_TAB_BATESNUMBERING_REMOVEALL,
  ORGANIZE_TAB_BACKGROUND,
  ORGANIZE_TAB_BACKGROUND_ADD,
  ORGANIZE_TAB_BACKGROUND_UPDATE,
  ORGANIZE_TAB_BACKGROUND_REMOVEALL,

  ORGANIZE_TAB_HEADER_FOOTER,
  ORGANIZE_TAB_HEADER_FOOTER_ADD,
  ORGANIZE_TAB_HEADER_FOOTER_UPDATE,
  ORGANIZE_TAB_HEADER_FOOTER_REMOVEALL,

  ORGANIZE_TAB_BATES_NUMBERING,
  ORGANIZE_TAB_BATES_NUMBERING_ADD,
  ORGANIZE_TAB_BATES_NUMBERING_REMOVEALL,

  ORGANIZE_TAB_PAGE_INSERT_FROM_FILE,
  ORGANIZE_TAB_PAGE_INSERT_FROM_CLIPBOARD,
  ORGANIZE_TAB_PAGE_INSERT_BLANK_PAGE,
  ORGANIZE_TAB_PAGE_INSERT_INTO_FILE,
  ORGANIZE_TAB_PAGE_REVERSE,
  ORGANIZE_TAB_PAGE_DELETE,
  ORGANIZE_TAB_PAGE_ROTATE,
  ORGANIZE_TAB_PAGE_DUPLICATE,
  ORGANIZE_TAB_PAGE_CROP,
  ORGANIZE_TAB_PAGE_ROTATE_LEFT,
  ORGANIZE_TAB_PAGE_ROTATE_RIGHT,
  ORGANIZE_TAB_PAGE_ROTATE_MULTIPLE,
  ORGANIZE_TAB_REPLACE,
  ORGANIZE_TAB_SWAP,
  ORGANIZE_TAB_FORMAT_PAGE_NUMBERS,
  HOME_TAB_PAGE_ROTATE,
  HOME_TAB_PAGE_ROTATE_LEFT,
  HOME_TAB_PAGE_ROTATE_RIGHT,
  HOME_TAB_PAGE_ROTATE_MULTIPLE,
} from './organize.constants';
import {
  OPEN_FILE_LOCAL,
  OPEN_FILE_FROM_URL,
  OPEN_FILE_FROM_GOOGLE_DRIVE,
  OPEN_FILE_FROM_RECENT,
  OPEN_FILE_FROM_DOCUMENTS,
  OPEN_FILE_FROM_ONE_DRIVE,
  OPEN_FILE_FROM_DRIVES,
  OPEN_FILE_FROM_BOX,
  OPEN_FILE_FROM_DROPBOX,
  OPEN_FILE_FROM_PRIVATE_DRIVE,
  OPEN_FILE_FROM_PRIVATE_DRIVE_S3,
  OPEN_FILE_FROM_PRIVATE_DRIVE_NFS,
  OPEN_FILE_FROM_IMANAGE,
  //OPEN_FILE_FROM_GET_START_GUID,
} from './openfile.constants';
import {
  OPEN_FILE_FROM_URL_MOBILE,
  USER_ENTRY_SIGN_IN,
  USER_ENTRY_SIGN_UP,
  USER_SWITCH_LANGUAGE,
  USER_GOTO_ADMIN_CONSOLE,
  USER_GOTO_EXIT,
  USER_POLICY,
  USER_TERMS,
  USER_ACCOUNT,
  USER_SWITCH_LANGUAGE_EN,
  USER_SWITCH_LANGUAGE_ZH,
  USER_SWITCH_LANGUAGE_JA,
  USER_SWITCH_LANGUAGE_DE,
  USER_SWITCH_LANGUAGE_FR,
  USER_SWITCH_LANGUAGE_KO
} from './mobile.constants';
import {
  SAVE_TO_LOCAL,
  SAVE_AS_FILE,
  SAVE_TO_DOWNLOAD,
  SAVE_TO_GOOGLE_DRIVE,
  SAVE_TO_ONE_DRIVE,
  SAVE_TO_BOX,
  SAVE_TO_DROPBOX,
  SAVE_TO_DRIVES,
  SAVE_TO_PRIVATE_DRIVE,
  SAVE_TO_PRIVATE_DRIVE_S3,
  SAVE_TO_PRIVATE_DRIVE_NFS, SAVE_FILE_BTN_HIDDEN_SLOT, SAVE_TO_IMANAGE,
  SAVE_TO_FOXIT_STORAGE,
} from './savefile.constants';
import { FEEDBACK, FOXIT_SOFTWARE, EDU_EXCLUSIVE, HELP_CENTER, DOWNLOAD_CLIENT, /* HELP_LIST, */ UPDATE_LOGS, FOXIT_PLUG_INS, ESIGN_CN_FEEDBACK } from './help.constants';
import { REQUEST_SIGNATURE, AGREEMENT_STATUS } from './fill_sign.constants'
import { PROTECT_LIST, PROTECT_DIGITAL_IDS, PROTECT_CERTIFICATE_PROTECT, PROTECT_SECURITY_POLICIES, PROTECT_SECURITY_PROPERTIES } from './protect.constants';
import { VIEW_LIST } from './view.constants';
import { EDIT_ALL_LIST, EDIT_TO_ADD_IMAGE, EDIT_APPEND_ALL_WEB_LINKS, EDIT_VIEW_WEB_LINKS, EDIT_SEARCH_REPLACE, FW_DOWNLOAD_FILE_BUTTON } from './edit.constants';// EDIT_LIST
import {
  FORM_ALL_LIST, /* FORM_IMPORT_FORM, */ FORM_RESET_FIELD, FORM_COMBINE_FORMS_TO_SHEET, FORM_ADD_TOOLTIP,
  FORM_CREATE_TEXT_FIELD, FORM_CREATE_SIGN_FIELD, FORM_CREATE_RADIO_BTN_FIELD, FORM_CREATE_PUSH_BTN_FIELD,
  FORM_CREATE_CHECK_BOX_FIELD, FORM_RECOGNITION_FORM
} from "./form.constants";
import { SIDEBAR_LIST, SIDEBAR_COMMENT_CARD_LIST, SIDEBAR_COMMENT_LIST/* , SIDEBAR_IMPORT_COMMENT */ } from './sidebar.constants';
import { PORTFOLIO_LIST } from './portfolio.constants';
import { COMMENTS_LIST,COMMENT_EXPORT_WORD_BUTTON } from './comment.constants';
import { FILL_SIGN_LIST, MANAGE_SIGNATURE, APPLY_ALL_SIGNATURE, DOCUMENT_STATUS, CLOSE_SIGN, FILL_SIGN_BUTTON, FILL_SIGN_BUTTON_HOME, SWITCH_ACCOUNTS } from 'Components/viewer/ui/constants/fill_sign.constants';
import {
  //FIRST_PAGE,
  //LAST_PAGE,
  //FULL_SCREEN,
  ROTATE_LEFT,
  ROTATE_RIGHT,
  FLOAT_BAR_BUILD_IN_LIST,
  //PREVIOUS_VIEW,
  //NEXT_VIEW,
  //PIN,
  //UN_PIN,
  //FIT_WIDTH,
} from './float_bar.constants'
import {
  COMMENTS_SELECTION_TOOLTIP_MAP
} from './comments.tooltip.constants'
import {
  PE_PLUGIN_ALL_BTNS
} from './plugin.constants';

import {
  PAPER_CHECK,
  PAPER_CHECK_HISTORY,
  PAPER_CHECK_NEW,
  PAPER_CHECK_PUBLISHED,
  PAPER_CHECK_NEW_HOME,
  PAPER_CHECK_PUBLISHED_HOME
} from './paper-check'


export {
  SIDEBAR_LIST,
  SIDEBAR_COMMENT_LIST,
  SIDEBAR_COMMENT_CARD_LIST,
  EDIT_TO_ADD_IMAGE
};

export const BUTTONS_BY_PERMISSION = [
  ORGANIZE_TAB_FLATTEN,

  ORGANIZE_TAB_WATERMARK,
  ORGANIZE_TAB_WATERMARK_ADD,
  ORGANIZE_TAB_WATERMARK_UPDATE,
  ORGANIZE_TAB_WATERMARK_REMOVEALL,
  HOME_TAB_WATERMARK_REMOVEALL,
  HOME_TAB_BACKGROUND_REMOVEALL,
  HOME_TAB_HEADERFOOTER_REMOVEALL,
  HOME_TAB_BATESNUMBERING_REMOVEALL,
  ORGANIZE_TAB_BACKGROUND,
  ORGANIZE_TAB_BACKGROUND_ADD,
  ORGANIZE_TAB_BACKGROUND_UPDATE,
  ORGANIZE_TAB_BACKGROUND_REMOVEALL,

  ORGANIZE_TAB_HEADER_FOOTER,
  ORGANIZE_TAB_HEADER_FOOTER_ADD,
  ORGANIZE_TAB_HEADER_FOOTER_UPDATE,
  ORGANIZE_TAB_HEADER_FOOTER_REMOVEALL,

  ORGANIZE_TAB_BATES_NUMBERING,
  ORGANIZE_TAB_BATES_NUMBERING_ADD,
  ORGANIZE_TAB_BATES_NUMBERING_REMOVEALL,

  CONVERT_EXPORT_IMAGES,
  CONVERT_PDF_TO_OFFICE,
  CONVERT_PDF_TO_WORD,
  CONVERT_PDF_TO_XML_SPREADSHEET_2003,
  CONVERT_PDF_TO_WORD_2003,
  CONVERT_PDF_TO_EXCEL,
  CONVERT_PDF_TO_PPT,
  OCR_PDF_TO_PDF,
  CONVERT_PDF_TO_IMAGE,
  CONVERT_PDF_TO_PNG,
  CONVERT_PDF_TO_JPEG,
  CONVERT_PDF_TO_JPEG2000,
  CONVERT_PDF_TO_TIFF,
  CONVERT_PDF_TO_BMP,
  CONVERT_PDF_TO_OTHER,
  CONVERT_PDF_TO_XML_STARDARD,
  CONVERT_PDF_TO_RTF,
  CONVERT_PDF_TO_TXT,
  CONVERT_PDF_TO_ACCESSIBLE_TXT,
  CONVERT_PDF_TO_HTML,
  PROTECT_CERTIFICATE_PROTECT,
  PROTECT_SECURITY_POLICIES,
  CONVERT_PREFLIGHT,
  FILE_TAB_GROUP_FILE_OPTIMIZER,
  ORGANIZE_TAB_PAGE_ROTATE,
  ORGANIZE_TAB_PAGE_ROTATE_LEFT,
  ORGANIZE_TAB_PAGE_ROTATE_RIGHT,
  ROTATE_LEFT,
  ROTATE_RIGHT,
  FORM_RESET_FIELD,
  FORM_ADD_TOOLTIP,
  FORM_RECOGNITION_FORM,
  FORM_CREATE_TEXT_FIELD,
  FORM_CREATE_SIGN_FIELD,
  FORM_CREATE_RADIO_BTN_FIELD,
  FORM_CREATE_PUSH_BTN_FIELD,
  FORM_CREATE_CHECK_BOX_FIELD,
  OCR_QUICK_RECOGNITION,
  MANAGE_SIGNATURE,
  APPLY_ALL_SIGNATURE,
  HELP_CUSTOMER_SERVICE,
  HELP_ABOUT,
  HELP_OPEN_MEMBER,
  HELP_EXCHANGE_MEMBER
]

export function isForConvert(name) {
  return CONVERT_LIST.indexOf(name) !== -1 ? true : false;
}
// FILE_SELECTOR_EXTERNAL: external embedded, append 'file selector' component to viewer,
// FILE_SELECTOR_INNER   : inner
// 1. here, file data will tranfer to callback
export const FILE_SELECTOR_EXTERNAL = [
  CONVERT_FILES_TO_PDF,
  // CONVERT_NEW_PORTFOLIO,
  //OPEN_FILE_LOCAL
];
// 2. here, file data only be used for viewer
export const FILE_SELECTOR_INNER = [
  //SIDEBAR_IMPORT_COMMENT,
  EDIT_TO_ADD_IMAGE,
  //FORM_IMPORT_FORM
]

export const PRIVATE_STORAGE_BTNS = [
  OPEN_FILE_FROM_PRIVATE_DRIVE, SAVE_TO_PRIVATE_DRIVE
]

const FILE_SELECTOR_LIST = [
  ...FILE_SELECTOR_EXTERNAL,
  ...FILE_SELECTOR_INNER
]

export function isFileSelector(name) {
  return FILE_SELECTOR_LIST.indexOf(name) !== -1 ? true : false;
}

export function isAnnotTooltip(name) {
  return COMMENTS_SELECTION_TOOLTIP_MAP.indexOf(name) !== -1;
}

const BUILT_IN_BUTTONS = [
  //OPEN_FILE_LOCAL,
  OPEN_FILE_FROM_URL,
  OPEN_FILE_FROM_URL_MOBILE,
  SAVE_TO_DOWNLOAD,
  // common in all tabs
  ...COMMON_ALL_LIST,
  // home
  ...HOME_ALL_LIST,
  // file
  FILE_TAB_FILE_PROPERTIES,
  // comments
  ...COMMENTS_LIST,
  // protect
  ...PROTECT_LIST,
  ...VIEW_LIST,
  // edit
  //...EDIT_LIST,
  ...EDIT_ALL_LIST,
  // form
  ...FORM_ALL_LIST,
  // sidebar
  ...SIDEBAR_COMMENT_LIST,
  ...SIDEBAR_LIST,
  // floatBar
  ...FLOAT_BAR_BUILD_IN_LIST,
  //...COMMENTS_SELECTION_TOOLTIP_MAP
  // pageEditor plugin
  ...PE_PLUGIN_ALL_BTNS,
  ...FILL_SIGN_LIST,
  //portfolios
  ...PORTFOLIO_LIST,
  ORGANIZE_TAB_EXTRACT,
  ORGANIZE_TAB_REPLACE,
  ORGANIZE_TAB_SPLIT,
  ORGANIZE_TAB_SWAP,
  ORGANIZE_TAB_FORMAT_PAGE_NUMBERS,
  ORGANIZE_TAB_PAGE_INSERT_FROM_FILE,
  ORGANIZE_TAB_PAGE_INSERT_FROM_CLIPBOARD,
  ORGANIZE_TAB_PAGE_INSERT_BLANK_PAGE,
  ORGANIZE_TAB_PAGE_INSERT_INTO_FILE,
  ORGANIZE_TAB_PAGE_REVERSE,
  ORGANIZE_TAB_PAGE_DELETE,
  ORGANIZE_TAB_PAGE_DUPLICATE,
  ORGANIZE_TAB_PAGE_CROP,
];

const ONLINE_NEW_BUTTONS = [
  FW_DOWNLOAD_FILE_BUTTON,
  CONVERT_PDF_TO_IMG,
  EXPORT_ALL_IMG,
  OCR_PDF_TO_PDF,
  //comment
  COMMENT_EXPORT_WORD_BUTTON,
  //edit
  EDIT_APPEND_ALL_WEB_LINKS,
  EDIT_VIEW_WEB_LINKS,
  // home => open
  OPEN_FILE_LOCAL,
  //OPEN_FILE_FROM_URL,
  OPEN_FILE_FROM_GOOGLE_DRIVE,
  OPEN_FILE_FROM_IMANAGE,
  OPEN_FILE_FROM_RECENT,
  OPEN_FILE_FROM_DOCUMENTS,
  OPEN_FILE_FROM_ONE_DRIVE,
  OPEN_FILE_FROM_BOX,
  OPEN_FILE_FROM_DROPBOX,
  OPEN_FILE_FROM_DRIVES,
  OPEN_FILE_FROM_PRIVATE_DRIVE,
  OPEN_FILE_FROM_PRIVATE_DRIVE_S3,
  OPEN_FILE_FROM_PRIVATE_DRIVE_NFS,

  // home => save
  SAVE_TO_LOCAL,
  SAVE_FILE_BTN_HIDDEN_SLOT,
  SAVE_AS_FILE,
  SAVE_TO_GOOGLE_DRIVE,
  SAVE_TO_IMANAGE,
  SAVE_TO_ONE_DRIVE,
  SAVE_TO_BOX,
  SAVE_TO_DROPBOX,
  SAVE_TO_DRIVES,
  SAVE_TO_PRIVATE_DRIVE,
  SAVE_TO_PRIVATE_DRIVE_S3,
  SAVE_TO_PRIVATE_DRIVE_NFS,
  SAVE_TO_FOXIT_STORAGE,
  // protect
  PROTECT_DIGITAL_IDS,
  PROTECT_CERTIFICATE_PROTECT,
  PROTECT_SECURITY_POLICIES,
  PROTECT_SECURITY_PROPERTIES,
  // convert
  CONVERT_FILES_TO_PDF,
  CONVERT_MUL_FILES_TO_PDF,
  CONVERT_TO_PDF_SETTINGS,
  CREATE_BLANK_PDF,
  CONVERT_CLIPBOARD_TO_PDF,
  CONVERT_HTML_TO_PDF,
  CONVERT_BLANK_PORTFOLIO,
  CONVERT_COMBINE_FILES,
  CONVERT_FROM_TEMPLATE,
  CONVERT_EXPORT_IMAGES,
  CONVERT_PDF_TO_WORD,
  CONVERT_PDF_TO_XML_SPREADSHEET_2003,
  CONVERT_NEW_PORTFOLIO,
  CONVERT_PDF_TO_WORD_2003,
  CONVERT_PDF_TO_EXCEL,
  CONVERT_PDF_TO_PPT,
  CONVERT_PDF_TO_PNG,
  CONVERT_PDF_TO_JPEG,
  CONVERT_PDF_TO_JPEG2000,
  CONVERT_PDF_TO_TIFF,
  CONVERT_PDF_TO_BMP,
  CONVERT_PDF_TO_XML_STARDARD,
  CONVERT_PDF_TO_RTF,
  CONVERT_PDF_TO_TXT,
  CONVERT_PDF_TO_ACCESSIBLE_TXT,
  CONVERT_PDF_TO_HTML,
  // ocr
  OCR_QUICK_RECOGNITION,
  HOME_OCR_QUICK_RECOGNITION,
  CONVERT_PREFLIGHT,
  // file
  FILE_TAB_TRUST_MANAGER,
  FILE_TAB_FILE_PREFERENCES,
  FILE_TAB_PDF_OPTIMIZER,
  FILE_TAB_PDF_REDUCE_SIZE,
  FILE_TAB_PDF_OPTIMIZER_SCANNED,
  CREATE_NEW_ACTION,
  RUN_ACTION,
  MANAGE_ACTIONS,
  // organize
  ORGANIZE_TAB_MOVE,
  ORGANIZE_TAB_FLATTEN,

  ORGANIZE_TAB_WATERMARK,
  ORGANIZE_TAB_WATERMARK_ADD,
  ORGANIZE_TAB_WATERMARK_UPDATE,
  ORGANIZE_TAB_WATERMARK_REMOVEALL,
  HOME_TAB_WATERMARK_REMOVEALL,
  HOME_TAB_BACKGROUND_REMOVEALL,
  HOME_TAB_HEADERFOOTER_REMOVEALL,
  HOME_TAB_BATESNUMBERING_REMOVEALL,
  HOME_TAB_PAGE_ROTATE,
  HOME_TAB_PAGE_ROTATE_LEFT,
  HOME_TAB_PAGE_ROTATE_RIGHT,
  HOME_TAB_PAGE_ROTATE_MULTIPLE,

  ORGANIZE_TAB_BACKGROUND,
  ORGANIZE_TAB_BACKGROUND_ADD,
  ORGANIZE_TAB_BACKGROUND_UPDATE,
  ORGANIZE_TAB_BACKGROUND_REMOVEALL,

  ORGANIZE_TAB_HEADER_FOOTER,
  ORGANIZE_TAB_HEADER_FOOTER_ADD,
  ORGANIZE_TAB_HEADER_FOOTER_UPDATE,
  ORGANIZE_TAB_HEADER_FOOTER_REMOVEALL,

  ORGANIZE_TAB_BATES_NUMBERING,
  ORGANIZE_TAB_BATES_NUMBERING_ADD,
  ORGANIZE_TAB_BATES_NUMBERING_REMOVEALL,

  ORGANIZE_TAB_PAGE_ROTATE,
  ORGANIZE_TAB_PAGE_ROTATE_LEFT,
  ORGANIZE_TAB_PAGE_ROTATE_RIGHT,
  ORGANIZE_TAB_PAGE_ROTATE_MULTIPLE,

  // form
  FORM_RESET_FIELD,
  FORM_COMBINE_FORMS_TO_SHEET,
  // FORM_ADD_TOOLTIP,
  // floatBar
  //FULL_SCREEN,
  //FIRST_PAGE,
  //PIN,
  //FIT_WIDTH,
  //UN_PIN,
  //LAST_PAGE,
  //PREVIOUS_VIEW,
  //NEXT_VIEW,
  ROTATE_LEFT,
  ROTATE_RIGHT,
  // help
  FEEDBACK,
  ESIGN_CN_FEEDBACK,
  FOXIT_SOFTWARE,
  EDU_EXCLUSIVE,
  HELP_CENTER,
  UPDATE_LOGS,
  DOWNLOAD_CLIENT,
  FOXIT_PLUG_INS,
  ...COMMENTS_SELECTION_TOOLTIP_MAP,
  // fill&sign
  AGREEMENT_STATUS,
  REQUEST_SIGNATURE,
  // viewer
  VIEW_TAB_COMPARE,
  // help
  HELP_CUSTOMER_SERVICE,
  HELP_ABOUT,
  HELP_OPEN_MEMBER,
  HELP_EXCHANGE_MEMBER,
  // online esign
  MANAGE_SIGNATURE,
  APPLY_ALL_SIGNATURE,
  DOCUMENT_STATUS,
  CLOSE_SIGN,
  FILL_SIGN_BUTTON,
  FILL_SIGN_BUTTON_HOME,
  PAPER_CHECK,
  PAPER_CHECK_HISTORY,
  PAPER_CHECK_NEW,
  PAPER_CHECK_PUBLISHED,
  PAPER_CHECK_NEW_HOME,
  PAPER_CHECK_PUBLISHED_HOME,
  SWITCH_ACCOUNTS,
];

let BUILT_IN_AUTO_NAME_BUTTONS = [];
export function addAutoNameBuiltIn(name) {
  BUILT_IN_AUTO_NAME_BUTTONS.push(name);
}
export function isBuiltIn(name) {
  let isBuiltIn = BUILT_IN_BUTTONS.indexOf(name) !== -1 ? true : false;
  if (isBuiltIn) return isBuiltIn;
  return BUILT_IN_AUTO_NAME_BUTTONS.indexOf(name) !== -1 ? true : false;
}
const FOR_DOWNLOAD_LIST = [
  SAVE_TO_LOCAL,
  SAVE_TO_DOWNLOAD
]
export function isDownload(name) {
  return FOR_DOWNLOAD_LIST.indexOf(name) !== -1 ? true : false;
}
const FOR_USER_ACTION = [
  USER_ENTRY_SIGN_IN,
  USER_ENTRY_SIGN_UP,
  USER_SWITCH_LANGUAGE,
  USER_SWITCH_LANGUAGE_EN,
  USER_SWITCH_LANGUAGE_ZH,
  USER_SWITCH_LANGUAGE_JA,
  USER_SWITCH_LANGUAGE_DE,
  USER_SWITCH_LANGUAGE_FR,
  USER_SWITCH_LANGUAGE_KO,
  USER_GOTO_ADMIN_CONSOLE,
  USER_GOTO_EXIT,
  FOXIT_SOFTWARE,
  EDU_EXCLUSIVE
]

export function isUserAction(name) {
  return FOR_USER_ACTION.indexOf(name) !== -1 ? true : false;
}
export function isMobile() {
  return IS_MOBILE;
}
export const COMMON_BUTTONS = [
  ...ONLINE_NEW_BUTTONS,
  // built-in buttons
  ...BUILT_IN_BUTTONS,

  EDIT_SEARCH_REPLACE,
];
permissionManager.resigterFeaturesGroup('ALL_FEATURES', COMMON_BUTTONS);
export const COMMON_BUTTONS_MOBILE = [
  //...COMMON_BUTTONS,
  USER_ENTRY_SIGN_IN,
  USER_ENTRY_SIGN_UP,
  USER_SWITCH_LANGUAGE,
  USER_SWITCH_LANGUAGE_EN,
  USER_SWITCH_LANGUAGE_ZH,
  USER_SWITCH_LANGUAGE_JA,
  USER_SWITCH_LANGUAGE_DE,
  USER_SWITCH_LANGUAGE_FR,
  USER_SWITCH_LANGUAGE_KO,
  USER_GOTO_ADMIN_CONSOLE,
  USER_GOTO_EXIT,
  USER_POLICY,
  USER_TERMS,
  USER_ACCOUNT,
  // TODO: next move to COMMON_BUTTONS
  ...ONLINE_NEW_BUTTONS,
  SAVE_TO_DOWNLOAD,
  // built-in buttons
  ...BUILT_IN_BUTTONS,
];
